import { NgModule } from '@angular/core';
import {DigAppService} from './services/dig-app.service';



@NgModule({
  providers: [DigAppService]
})
export class DigModule { }
